import {
    DEBUG_HIDE_DEVTOOLS,
    DEBUG_SHOW_DEVTOOLS,
    //
    DEBUG_HIDE_MEMCONSUMPTION,
    DEBUG_SHOW_MEMCONSUMPTION,
    //
    DEBUG_ENABLE_FORM_DEBUG_ALL,
    DEBUG_DISABLE_FORM_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORM_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORM_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORM_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORM_DEBUG,
    //
    DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG,
    DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG,
    //
    DEBUG_ENABLE_DATATABLE_DEBUG_ALL,
    DEBUG_DISABLE_DATATABLE_DEBUG_ALL,
    DEBUG_ADD_DEDICATED_DATATABLE_DEBUG,
    DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG,
    DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG,
    //
    DEBUG_ENABLE_WEBSOCKET_DEBUG,
    DEBUG_DISABLE_WEBSOCKET_DEBUG
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

export type ShowDevToolsAction = {
    type : typeof DEBUG_SHOW_DEVTOOLS;
};
export const showDevTools = () : ShowDevToolsAction => {
    return {
        type: DEBUG_SHOW_DEVTOOLS
    };
};

export type HideDevToolsAction = {
    type : typeof DEBUG_HIDE_DEVTOOLS;
};
export const hideDevTools = () : HideDevToolsAction => {
    return {
        type: DEBUG_HIDE_DEVTOOLS
    };
};

export type ShowMemoryConsumptionAction = {
    type : typeof DEBUG_SHOW_MEMCONSUMPTION;
};
export const showMemoryConsumption = () : ShowMemoryConsumptionAction => {
    return {
        type: DEBUG_SHOW_MEMCONSUMPTION
    };
};

export type HideMemoryConsumptionAction = {
    type : typeof DEBUG_HIDE_MEMCONSUMPTION;
};
export const hideMemoryConsumption = () : HideMemoryConsumptionAction => {
    return {
        type: DEBUG_HIDE_MEMCONSUMPTION
    };
};

export type EnableFormDebugAllAction = {
    type : typeof DEBUG_ENABLE_FORM_DEBUG_ALL;
};
export const enableFormDebugAll = () : EnableFormDebugAllAction => {
    return {
        type: DEBUG_ENABLE_FORM_DEBUG_ALL
    };
};

export type DisableFormDebugAllAction = {
    type : typeof DEBUG_DISABLE_FORM_DEBUG_ALL;
};
export const disableFormDebugAll = () : DisableFormDebugAllAction => {
    return {
        type: DEBUG_DISABLE_FORM_DEBUG_ALL
    };
};

export type AddDedicatedFormDebugAction = {
    formUid : string;
    type : typeof DEBUG_ADD_DEDICATED_FORM_DEBUG;
};
export const addDedicatedFormDebug = ( formUid : string ) : AddDedicatedFormDebugAction => {
    return {
        formUid,
        type: DEBUG_ADD_DEDICATED_FORM_DEBUG
    };
};

export type RemoveDedicatedFormDebugAction = {
    formUid : string;
    type : typeof DEBUG_REMOVE_DEDICATED_FORM_DEBUG;
};
export const removeDedicatedFormDebug = ( formUid : string ) : RemoveDedicatedFormDebugAction => {
    return {
        formUid,
        type: DEBUG_REMOVE_DEDICATED_FORM_DEBUG
    };
};

export type EnableDedicatedFormDebugAction = {
    formUid : string;
    type : typeof DEBUG_ENABLE_DEDICATED_FORM_DEBUG;
};
export const enableDedicatedFormDebug = ( formUid : string ) : EnableDedicatedFormDebugAction => {
    return {
        formUid,
        type: DEBUG_ENABLE_DEDICATED_FORM_DEBUG
    };
};

export type DisableDedicatedFormDebugAction = {
    formUid : string;
    type : typeof DEBUG_DISABLE_DEDICATED_FORM_DEBUG;
};
export const disableDedicatedFormDebug = ( formUid : string ) : DisableDedicatedFormDebugAction => {
    return {
        formUid,
        type: DEBUG_DISABLE_DEDICATED_FORM_DEBUG
    };
};

export type EnableFormDesignerDebugAllAction = {
    type : typeof DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL;
};
export const enableFormDesignerDebugAll = () : EnableFormDesignerDebugAllAction => {
    return {
        type: DEBUG_ENABLE_FORMDESIGNER_DEBUG_ALL
    };
};

export type DisableFormDesignerDebugAllAction = {
    type : typeof DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL;
};
export const disableFormDesignerDebugAll = () : DisableFormDesignerDebugAllAction => {
    return {
        type: DEBUG_DISABLE_FORMDESIGNER_DEBUG_ALL
    };
};

export type AddDedicatedFormDesignerDebugAction = {
    formUid : string;
    type : typeof DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG;
};
export const addDedicatedFormDesignerDebug = ( formUid : string ) : AddDedicatedFormDesignerDebugAction => {
    return {
        formUid,
        type: DEBUG_ADD_DEDICATED_FORMDESIGNER_DEBUG
    };
};

export type RemoveDedicatedFormDesignerDebugAction = {
    formUid : string;
    type : typeof DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG;
};
export const removeDedicatedFormDesignerDebug = ( formUid : string ) : RemoveDedicatedFormDesignerDebugAction => {
    return {
        formUid,
        type: DEBUG_REMOVE_DEDICATED_FORMDESIGNER_DEBUG
    };
};

export type EnableDedicatedFormDesignerDebugAction = {
    formUid : string;
    type : typeof DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG;
};
export const enableDedicatedFormDesignerDebug = ( formUid : string ) : EnableDedicatedFormDesignerDebugAction => {
    return {
        formUid,
        type: DEBUG_ENABLE_DEDICATED_FORMDESIGNER_DEBUG
    };
};

export type DisableDedicatedFormDesignerDebugAction = {
    formUid : string;
    type : typeof DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG;
};
export const disableDedicatedFormDesignerDebug = ( formUid : string ) : DisableDedicatedFormDesignerDebugAction => {
    return {
        formUid,
        type: DEBUG_DISABLE_DEDICATED_FORMDESIGNER_DEBUG
    };
};

export type EnableDataTableDebugAllAction = {
    type : typeof DEBUG_ENABLE_DATATABLE_DEBUG_ALL;
};
export const enableDataTableDebugAll = () : EnableDataTableDebugAllAction => {
    return {
        type: DEBUG_ENABLE_DATATABLE_DEBUG_ALL
    };
};

export type DisableDataTableDebugAllAction = {
    type : typeof DEBUG_DISABLE_DATATABLE_DEBUG_ALL;
};
export const disableDataTableDebugAll = () : DisableDataTableDebugAllAction => {
    return {
        type: DEBUG_DISABLE_DATATABLE_DEBUG_ALL
    };
};

export type AddDedicatedDataTableDebugAction = {
    dataTableUid : string;
    type : typeof DEBUG_ADD_DEDICATED_DATATABLE_DEBUG;
};
export const addDedicatedDataTableDebug = ( dataTableUid : string ) : AddDedicatedDataTableDebugAction => {
    return {
        dataTableUid,
        type: DEBUG_ADD_DEDICATED_DATATABLE_DEBUG
    };
};

export type RemoveDedicatedDataTableDebugAction = {
    dataTableUid : string;
    type : typeof DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG;
};
export const removeDedicatedDataTableDebug = ( dataTableUid : string ) : RemoveDedicatedDataTableDebugAction => {
    return {
        dataTableUid,
        type: DEBUG_REMOVE_DEDICATED_DATATABLE_DEBUG
    };
};

export type EnableDedicatedDataTableDebugAction = {
    dataTableUid : string;
    type : typeof DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG;
};
export const enableDedicatedDataTableDebug = ( dataTableUid : string ) : EnableDedicatedDataTableDebugAction => {
    return {
        dataTableUid,
        type: DEBUG_ENABLE_DEDICATED_DATATABLE_DEBUG
    };
};

export type DisableDedicatedDataTableDebugAction = {
    dataTableUid : string;
    type : typeof DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG;
};
export const disableDedicatedDataTableDebug = ( dataTableUid : string ) : DisableDedicatedDataTableDebugAction => {
    return {
        dataTableUid,
        type: DEBUG_DISABLE_DEDICATED_DATATABLE_DEBUG
    };
};

export type EnableWebSocketDebugAction = {
    type : typeof DEBUG_ENABLE_WEBSOCKET_DEBUG;
};
export const enableWebSocketDebug = () : EnableWebSocketDebugAction => {
    return {
        type: DEBUG_ENABLE_WEBSOCKET_DEBUG
    };
};

export type DisableWebSocketDebugAction = {
    type : typeof DEBUG_DISABLE_WEBSOCKET_DEBUG;
};
export const disableWebSocketDebug = () : DisableWebSocketDebugAction => {
    return {
        type: DEBUG_DISABLE_WEBSOCKET_DEBUG
    };
};


// convenience
export const showDebugInfo = () : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    dispatch( showDevTools() );
    dispatch( showMemoryConsumption() );
}
export const hideDebugInfo = () : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    dispatch( hideDevTools() );
    dispatch( hideMemoryConsumption() );
}
